import { render, staticRenderFns } from "./SanteIJH.vue?vue&type=template&id=21a9068e&"
import script from "./SanteIJH.vue?vue&type=script&lang=js&"
export * from "./SanteIJH.vue?vue&type=script&lang=js&"
import style0 from "./SanteIJH.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports